import React from 'react';
import { buyedPointsStyle as styles } from '../../purchaseHistory.tailwind';
import Coin from '../../../../assets/images/coin.png';
// import { formatDate } from '../PurchaseHistory/purchasedHistory.data';
import { Chip } from '@mui/material';
import { getTransactionStatus } from '../../../../lib/utils/paymentStatusUtils';
import { formatDate } from '../../../../lib/utils/dateAndTimeFormatting';

const BuyedPointCard = ({ purchase }) => {
  const { transactionStatus, statusColor } = getTransactionStatus(purchase?.paymentDetails?.transactionStatus); // Get status and color

  return (
    <div className={styles.purchaseItem}>
        <div className={styles.purchaseDetailsContainer}>
            <div className={styles.point_chipContainer}>
              <div className={styles.pointImage}>
                <img src={Coin} className='p-3' alt="Point" />
              </div>
              <Chip label={transactionStatus} color={statusColor} size="small" className={styles.point_chip}/>
            </div>
            <div className={styles.purchaseDetails}>
              <div className={styles.purchaseDate}>
                <div className="flex gap-[15px] items-center">
                  <span className='font-normal'>{purchase?.paymentDetails?.transactionDateTime ? formatDate(purchase?.paymentDetails?.transactionDateTime) : ''}</span>
                  <Chip label={transactionStatus} color={statusColor} size="small" className={styles.point_chip_lg}/>
                </div>
                <div className={styles.transactionContainer}>
                    {/* Transaction Id */}
                  <span className={styles.purchaseDetailsHeadings}>Transaction Id </span>
                  <span className={styles.point_transactionId}>{purchase?.paymentDetails?.transactionId.split("_")[1]}</span> 
                </div>
                  {/* payment method */}
                <div className={styles.purchasePoints}>
                  {/* <div className={styles.paymentMethod}> */}
                    <span className={styles.purchaseDetailsHeadings}>Payment Method</span>
                    {/* <span className='capitalize'>
                      {purchase?.paymentDetails?.paymentMethod === "card" && purchase?.paymentDetails?.displayBrand} {purchase?.paymentDetails?.paymentMethod}
                      </span> */}
                  {/* </div> */}
                  {purchase?.paymentDetails?.paymentMethod === "card" && purchase?.paymentDetails?.cardEndingNumber ? (
                    <div className={styles.paymentMethod}>
                      <span className={styles.detail_text}>
                      {purchase?.paymentDetails?.paymentMethod === "card" && purchase?.paymentDetails?.displayBrand} {purchase?.paymentDetails?.paymentMethod}
                      </span>
                      <span className={styles.detail_text}>( Ending in</span>
                      <span className={styles.detail_text}>{purchase?.paymentDetails?.cardEndingNumber} )</span>
                    </div>                      
                    ): (
                    <div className={styles.paymentMethod}>
                      <span className={styles.detail_text}>
                       {purchase?.paymentDetails?.paymentMethod}
                      </span>
                    </div>
                  )}
                </div>
              </div>
                {/* total points purchased */}
              <div className={styles.pointsPurchased}>
                <div className='flex flex-row items-baseline'>
                <span className={styles.pointDetailsHeadings}>Points</span>
                <span className={styles.point_data}>{purchase.points} </span>
                </div>
                {/* total */}
                <div className={styles.purchaseAmount}>
                  <span className={styles.pointDetailsHeadings}>Total</span>
                  <span className={styles.amount_data}> $ {purchase?.paymentDetails?.transactionAmount}</span>
                </div>
              </div>

              
            </div>

        </div>
    </div>
  );
};

export default BuyedPointCard;
